module.exports = __webpack_public_path__ + "images/ebooks/elearning-for-beginners-58ee34e1dfc49d0e0e16ca7f6519c227.webp";